(() => {
  const colours = [
    ['Choc Classic', '#a56a28'], ['Snow Pop', '#f7f5ef'], ['Fairy Floss', '#df98d0'],
    ['Electric Pink', '#eb27c9'], ['Sky Splash', '#62b2d9'], ['Blue Razz', '#3b39d9'],
    ['Jungle Jolt', '#55ab3f'], ['Lolly Lime', '#9ce936'], ['Cherry Pop', '#df3043'],
    ['Orange Sherbet', '#ef6d2a'], ['Lemon Fizz', '#fae84d'], ['Grape Pop', '#9851dc'],
    ['Aqua Pop', '#6bcbd2'], ['Midnight Magic', '#151515']
  ];
  const cardVariantId = '62865763598495';
  const foilVariantId = '62865763729567';
  const mixVariantId = '62865764090015';
  const ready = (callback) => {
    if (callback()) return;
    const observer = new MutationObserver(() => {
      if (callback()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };
  const makeChoice = (title, hint, property) => {
    const section = document.createElement('section');
    section.className = 'heartbreaker-builder__section';
    section.innerHTML = '<h3></h3><p></p><input type="hidden" name="properties[' + property + ']" value=""><div class="heartbreaker-builder__palette"></div><div class="heartbreaker-builder__picked">Choose a colour</div>';
    section.querySelector('h3').textContent = title;
    section.querySelector('p').textContent = hint;
    const input = section.querySelector('input');
    const picked = section.querySelector('.heartbreaker-builder__picked');
    const palette = section.querySelector('.heartbreaker-builder__palette');
    colours.forEach(([name, colour]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'heartbreaker-builder__colour';
      button.innerHTML = '<span></span><b></b>';
      button.querySelector('span').style.background = colour;
      button.querySelector('b').textContent = name;
      button.addEventListener('click', () => {
        input.value = name;
        palette.querySelectorAll('button').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        picked.textContent = 'Your choice: ' + name;
        picked.style.setProperty('--heart-colour', colour);
      });
      palette.append(button);
    });
    return section;
  };
  const build = () => {
    const form = document.querySelector('.js-product-form');
    if (!form || document.querySelector('.heartbreaker-builder')) return false;
    const removeLegacyControls = () => {
      document.querySelectorAll('.best-custom-product-options, .bcpo').forEach((legacy) => legacy.remove());
    };
    removeLegacyControls();
    const legacyCleaner = new MutationObserver(removeLegacyControls);
    legacyCleaner.observe(document.documentElement, { childList: true, subtree: true });
    const box = document.createElement('section');
    box.className = 'heartbreaker-builder';
    box.innerHTML = '<header><p>BUILD YOUR HEARTBREAKER</p><h2>Send a heart. Make it personal. Smash the surprise.</h2><span>One chocolate heart · candy-filled inside · wooden hammer included</span></header>';
    const base = makeChoice('1. Pick your heart colour', 'Choose the colour that says it best.', 'Heart colour');
    const message = makeChoice('2. Choose your letter colour', 'Pick a colour that pops.', 'Letter colour');
    const wording = document.createElement('section');
    wording.className = 'heartbreaker-builder__notes heartbreaker-builder__wording';
    wording.innerHTML = '<span>3. What would you like to say on your SmashCake?</span><small>Up to 3 lines · 8 characters per line</small><input type="hidden" name="properties[Words on SmashCake]" value=""><div class="heartbreaker-builder__word-lines"><input maxlength="8" required placeholder="LINE 1" aria-label="Message line 1"><input maxlength="8" placeholder="LINE 2" aria-label="Message line 2"><input maxlength="8" placeholder="LINE 3" aria-label="Message line 3"></div>';
    const wordingInput = wording.querySelector('input[type="hidden"]');
    const wordingLines = [...wording.querySelectorAll('.heartbreaker-builder__word-lines input')];
    const syncWords = () => {
      wordingInput.value = wordingLines.map((line) => line.value.trim()).filter(Boolean).join(' / ');
    };
    wordingLines.forEach((line) => line.addEventListener('input', syncWords));
    const mix = document.createElement('section');
    mix.className = 'heartbreaker-builder__section heartbreaker-builder__mix';
    mix.innerHTML = '<h3>5. Would you like a custom piñata mix inside <em>+$12</em></h3><p>Match the candy surprise inside to your theme—or keep our classic colourful party mix.</p><input type="hidden" name="properties[Piñata mix]" value="Classic party mix"><div class="heartbreaker-builder__mix-options"><button type="button" data-mix="Classic party mix" class="is-selected">Keep it classic</button></div>';
    const mixInput = mix.querySelector('input');
    const mixOptions = mix.querySelector('.heartbreaker-builder__mix-options');
    [['Pink','#df98d0'],['Blue','#3b39d9'],['Red','#df3043'],['Orange','#ef6d2a'],['Yellow','#fae84d'],['Green','#55ab3f']].forEach(([name,colour]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.mix = name;
      button.innerHTML = '<span></span>' + name;
      button.querySelector('span').style.background = colour;
      mixOptions.append(button);
    });
    mixOptions.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-mix]');
      if (!button) return;
      mixInput.value = button.dataset.mix;
      mixOptions.querySelectorAll('button').forEach((item) => item.classList.toggle('is-selected', item === button));
    });
    const foil = document.createElement('section');
    foil.className = 'heartbreaker-builder__section heartbreaker-builder__foil';
    foil.innerHTML = '<h3>4. Add a little shimmer</h3><p>Optional gold or silver foil to make your heart extra special.</p><div><label><input type="radio" name="properties[Foil finish]" value="No foil" checked><span>Keep it classic</span></label><label><input type="radio" name="properties[Foil finish]" value="Gold foil"><span>Gold foil · +$4</span></label><label><input type="radio" name="properties[Foil finish]" value="Silver foil"><span>Silver foil · +$4</span></label></div>';
    const card = document.createElement('section');
    card.className = 'heartbreaker-builder__card';
    card.innerHTML = '<label class="heartbreaker-builder__card-toggle"><input type="checkbox"><span><strong>Add a little love note inside</strong><small>A custom card tucked inside the SmashCake.</small></span><b>+$4</b></label><label class="heartbreaker-builder__card-message"><span>What should the card say?</span><textarea rows="3" placeholder="Write your message here..."></textarea></label>';
    const notes = document.createElement('label');
    notes.className = 'heartbreaker-builder__notes';
    notes.innerHTML = '<span>Anything else you would like?</span><textarea name="properties[Anything else we should know?]" rows="3" placeholder="Name, occasion, date, dream colour or allergy details — pop them here."></textarea>';
    box.append(base, message, wording, foil, mix, card, notes);
    const target = form.querySelector('[name="quantity"]')?.closest('.quantity-submit-row') || form.querySelector('button[type="submit"]')?.parentElement;
    if (target) target.insertAdjacentElement('beforebegin', box); else form.prepend(box);
    const cardToggle = card.querySelector('input[type="checkbox"]');
    const cardMessage = card.querySelector('textarea');
    cardToggle.addEventListener('change', () => {
      card.classList.toggle('is-open', cardToggle.checked);
      cardMessage.required = cardToggle.checked;
    });
    const selected = () => ({ base: base.querySelector('input').value, message: message.querySelector('input').value, words: (syncWords(), wordingInput.value.trim()) });
    let adding = false;
    const addPaidExtras = async () => {
      if (adding) return;
      const choices = selected();
      const foilChoice = foil.querySelector('input[name="properties[Foil finish]"]:checked')?.value || 'No foil';
      const mixChoice = mixInput.value || 'Classic party mix';
      if (!choices.base || !choices.message || !choices.words) {
        (!choices.base ? base : !choices.message ? message : wording).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (cardToggle.checked && !cardMessage.value.trim()) {
        cardMessage.focus();
        return;
      }
      const id = form.querySelector('[name="id"]')?.value;
      adding = true;
      if (!id) return;
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = value;
      });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id, quantity: 1, properties },
            ...(mixChoice !== 'Classic party mix' ? [{ id: mixVariantId, quantity: 1, properties: { 'Custom piñata mix colour': mixChoice } }] : []),
            ...(foilChoice !== 'No foil' ? [{ id: foilVariantId, quantity: 1, properties: { 'Foil finish': foilChoice } }] : []),
            ...(cardToggle.checked ? [{ id: cardVariantId, quantity: 1, properties: { 'Card message': cardMessage.value.trim() } }] : [])
          ]})
        });
        if (!response.ok) throw new Error('Could not add card');
        window.location.assign('/cart');
      } catch {
        adding = false;
        alert('We could not add your extras just now. Please try again.');
      }
    };
    const intercept = (event) => {
      const choices = selected();
      if (!choices.base || !choices.message || !choices.words) {
        event.preventDefault();
        event.stopImmediatePropagation();
        (!choices.base ? base : !choices.message ? message : wording).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const foilChoice = foil.querySelector('input[name="properties[Foil finish]"]:checked')?.value || 'No foil';
      const mixChoice = mixInput.value || 'Classic party mix';
      if (!cardToggle.checked && foilChoice === 'No foil' && mixChoice === 'Classic party mix') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addPaidExtras();
    };
    document.addEventListener('submit', (event) => {
      if (event.target === form) intercept(event);
    }, true);
    document.addEventListener('click', (event) => {
      const submit = event.target.closest('button[type="submit"], input[type="submit"]');
      if (submit && submit.closest('form') === form) intercept(event);
    }, true);
    return true;
  };
  ready(build);
})();